module.exports = __webpack_public_path__ + "media/images/gallery-image4-6cabce3097eebc16ddbc7a494744fee6.webp";